import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useAppMutation } from "@shared/hooks/useAppMutation";
import type { NotificationPreferenceDto } from "@yalana/contracts";
import {
  notificationsMutations,
  notificationsQueries,
} from "../api/notifications.queries";

export function useNotificationPreferences() {
  const queryClient = useQueryClient();

  const { data, isLoading } = useQuery(notificationsQueries.preferences());

  const mutation = useAppMutation({
    errorToast: "global",
    ...notificationsMutations.updatePreferences(),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: notificationsQueries.all(),
      });
    },
  });

  const toggle = (eventType: string, enabled: boolean) => {
    const current = data?.preferences ?? [];
    const updated: NotificationPreferenceDto[] = current.map((p) =>
      p.eventType === eventType ? { ...p, enabled } : p,
    );
    mutation.mutate(updated);
  };

  return {
    preferences: data?.preferences ?? [],
    isLoading,
    toggle,
    isSaving: mutation.isPending,
  };
}
